import React, { useState } from 'react'
import FileIcon from '@mui/icons-material/InsertDriveFile'
import clsx from 'clsx'
import { ListItem, ListItemText, ListItemAvatar } from '@mui/material'
import ModalEditFileNameInline from '../../modals/ModalEditFileNameInline'
import { useDropzoneContext } from '../../../contexts/DropzoneContext'
import EditRemoveButtonGroup from '../../Button/EditRemoveButtonGroup'

export type DropzoneFileListItemProps = {
	file: File
}

const DropzoneFileListItem = ({
	file,
}: DropzoneFileListItemProps) => {
	const { onRemoveFile, onUpdateFileName } = useDropzoneContext()

	const [editFileNameModalOpen, setEditFileNameModalOpen] =
		useState(false)

	const handleOpenEditFileNameModal = () => {
		setEditFileNameModalOpen(true)
	}

	const handleCloseEditFileNameModal = () => {
		setEditFileNameModalOpen(false)
	}

	const handleRemoveFile = () => {
		onRemoveFile(file)
	}

	return (
		<ListItem>
			<ListItemAvatar
				className={clsx(editFileNameModalOpen && 'hidden md:block')}
			>
				<FileIcon />
			</ListItemAvatar>
			<div className="relative w-full flex-1">
				<ListItemText primary={file.name} />
				{onUpdateFileName && (
					<ModalEditFileNameInline
						onSubmit={onUpdateFileName}
						onClose={handleCloseEditFileNameModal}
						visible={editFileNameModalOpen}
						file={file}
					/>
				)}
			</div>
			{!editFileNameModalOpen && (
				<EditRemoveButtonGroup
					onEdit={handleOpenEditFileNameModal}
					onRemove={handleRemoveFile}
				/>
			)}
		</ListItem>
	)
}

export default DropzoneFileListItem
